import React from 'react';
import ConfirmModal from '~/components/General/ConfirmModal';
import { DraftRecovery } from '~/assets/images';

const DraftRecoveryAlert = ({
  open,
  onClose,
  onContinue,
  onStartFresh,
  title,
  isAutoSaving,
  loadingCampaign,
  message,
}) => {
  return (
    <ConfirmModal
      openConfirmModal={{
        open: open && !isAutoSaving && !loadingCampaign,
        header: title,
        message,
        icon: DraftRecovery,
        handleClose: onClose,
        handleCancelBtn: onStartFresh,
        handleOk: onContinue,
        cancelButtonName: 'Start Fresh',
        successButtonName: 'Continue Editing',
      }}
    />
  );
};

export default DraftRecoveryAlert;
